import { HttpClient } from 'shared/libs/http';
import type { LoginResponse, User } from 'user/types';

export type CreateResumeProfileAccess = {
   allowed: boolean;
   user: User | null;
};

const hasValue = (value: unknown): boolean => {
   if (value === null || value === undefined) {
      return false;
   }

   if (typeof value === 'string') {
      return value.trim().length > 0;
   }

   return true;
};

export const isCreateResumeProfileFilled = (user: User): boolean => {
   const city = user.city ?? user.city_id;
   const country = user.country;
   const birthday = user.birthday;

   return [city, country, birthday].every(hasValue);
};

export const loadCreateResumeProfileAccess = async (): Promise<CreateResumeProfileAccess> => {
   const response = await HttpClient.post<LoginResponse>('/users/login-token', null);

   if (response.status !== 200) {
      return {
         allowed: false,
         user: null,
      };
   }

   return {
      allowed: isCreateResumeProfileFilled(response.response.user),
      user: response.response.user,
   };
};
